<template>
  <div>
    <div class="current_club">
      <img src="../assets/img/location.svg" alt="" class="club-icon">
      Ваш клуб:
      <span class="current_club_name">{{ currentClubName }}</span>
    </div>
    <div v-if="clubs.length === 0">{{ emptyText }}</div>
    <div class="clubs_list">
      <div class="club_item" v-for="club in clubs"
          :key="club.id"
          :class="{ active: club.id === $store.state.user.current_club }"
          @click="handleClick(club.id)"
      >
        <div class="club_data">
          <div class="club_name">
            {{ club.name }}
          </div>
          <div v-if="club.address.length !== 0" class="club_address">
            {{ club.address }}
          </div>
        </div>
        <div class="club_icon">
          <img src="../assets/img/check.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentClubName() {
      const currentClubId = this.$store.state.user.current_club;
      const currentClub = this.clubs.find(club => club.id === currentClubId);
      return currentClub ? currentClub.name : 'Клуб не выбран';
    }
  },
  props: {
    clubs: Array,
    emptyText: String,
    onClubSelect: Function
  },
  methods: {
    handleClick(id) {
      if (this.onClubSelect) {
        this.onClubSelect(id);
      }
    }
  }
}
</script>
